export default "__VITE_ASSET__CVkaYXgO__"